import { render, staticRenderFns } from "./BlockListSeoCities.vue?vue&type=template&id=6c279ba7&scoped=true&"
import script from "./BlockListSeoCities.vue?vue&type=script&lang=ts&"
export * from "./BlockListSeoCities.vue?vue&type=script&lang=ts&"
import style0 from "./BlockListSeoCities.vue?vue&type=style&index=0&id=6c279ba7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c279ba7",
  null
  
)

export default component.exports